<script>

export default {
  page: {
    title: 'Loading page...',
    meta: [{ name: 'description', content: 'Loading page...' }],
  },
  name: 'Loading',
}
</script>

<template>
  <!-- Pre-loader -->
  <div class="preloader">
    <div class="status">
      <div class="spinner">Loading...</div>
    </div>
  </div>
  <!-- End Preloader-->
</template>
